import React from "react";
import {
  ShieldCheck,
  Brush,
  Flag,
  Trophy,
  Palette,
  ExternalLink,
} from "lucide-react";
import { useQuote } from "../QuoteDialog";

const ITEMS = [
  { icon: ShieldCheck, text: "Laminate posters for long-term use" },
  { icon: Brush, text: "Create custom wall graphics" },
  { icon: Flag, text: "Produce finished banners ready to hang" },
  { icon: Trophy, text: "Build durable, professional displays" },
  { icon: Palette, text: "Run student design & media projects" },
];

export default function FinishingUnlocks() {
  const { openQuote } = useQuote();
  return (
    <section
      data-testid="finishing-unlocks-section"
      className="bg-[#F4F6F4] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="mb-14 max-w-3xl">
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-teal mb-4">
            What this unlocks
          </div>
          <h2
            data-testid="finishing-unlocks-headline"
            className="font-serif text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-navy leading-tight"
          >
            What Your School Can Do with a Complete Setup
          </h2>
        </div>

        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 mb-14">
          {ITEMS.map((it, i) => {
            const Icon = it.icon;
            return (
              <li
                key={it.text}
                data-testid={`finishing-unlock-${i}`}
                className="group bg-white border border-slate-200 hover:border-teal hover:shadow-md rounded-2xl p-6 transition-all flex flex-col"
              >
                <span className="w-11 h-11 rounded-lg bg-navy text-white flex items-center justify-center mb-4 group-hover:bg-teal transition-colors">
                  <Icon className="w-5 h-5" strokeWidth={2} />
                </span>
                <span className="font-serif text-base sm:text-lg font-bold text-navy leading-snug">
                  {it.text}
                </span>
              </li>
            );
          })}
        </ul>

        <div className="flex flex-col sm:flex-row sm:items-center gap-4 pt-8 border-t border-slate-200">
          <p className="text-base sm:text-lg text-slate-700 max-w-xl">
            Tell us what you want to create—we'll match the right combination of
            tools.
          </p>
          <button
            data-testid="finishing-unlocks-quote-btn"
            onClick={openQuote}
            title="Opens in a new tab"
            className="group inline-flex items-center justify-center gap-2 bg-teal hover:bg-[#0D6BB1] text-white font-bold px-7 py-3.5 rounded-lg shadow-md hover:shadow-lg transition-all duration-200 hover:-translate-y-0.5 whitespace-nowrap"
          >
            Request a Quote
            <ExternalLink className="w-5 h-5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
        </div>
      </div>
    </section>
  );
}
